<template>
    <div>
        <v-bottom-navigation
            v-model="bottomNav"
            height="65"
            fixed
            :value="activeBtn"
            grow
        >
            <v-btn class="mt-1" @click="homePage()">
                <span>Home</span>
                <v-icon>mdi-home-circle</v-icon>
            </v-btn>
            <v-btn
                class="mt-1"
                v-if="
                    chkViewMain === 'Pending' || chkViewMain === 'Schedule Case'
                "
                @click="getPage('Onsite')"
            >
                <v-badge
                    :color="
                        this.data_btn_menu[0].count == 0 ? '' : 'green accent-4'
                    "
                >
                    <span slot="badge">{{ this.data_btn_menu[0].count }}</span>
                    <v-icon>mdi-hammer-wrench</v-icon><br />
                    <span>Onsite</span>
                </v-badge>
            </v-btn>

            <v-btn
                class="mt-1"
                v-if="
                    chkViewMain === 'Onsite' || chkViewMain === 'Schedule Case'
                "
                @click="getPage('Pending')"
            >
                <v-badge
                    :color="
                        this.data_btn_menu[1].count == 0 ? '' : 'green accent-4'
                    "
                >
                    <span slot="badge">{{ this.data_btn_menu[1].count }}</span>
                    <v-icon>mdi-alert-outline</v-icon><br />
                    <span>Pending</span>
                </v-badge>
            </v-btn>

            <v-btn
                class="mt-1"
                v-if="chkViewMain === 'Onsite' || chkViewMain === 'Pending'"
                @click="getPage('Schedule Case')"
            >
                <v-badge
                    :color="
                        this.data_btn_menu[2].count == 0 ? '' : 'green accent-4'
                    "
                >
                    <span slot="badge">{{ this.data_btn_menu[2].count }}</span>
                    <v-icon>mdi-calendar-clock</v-icon><br />
                    <span>Schedule</span>
                </v-badge>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>
<script>
export default {
    props: ["chkViewMain", "data_btn_menu"],
    methods: {
        homePage() {
            this.$emit("homePage")
        },
        getPage(result) {
            this.$emit("pageToFoot", result)
        },
    },
    data() {
        return {
            activeBtn: 1,
            bottomNav: "",
        }
    },
}
</script>
<style scoped>
.v-badge__badge {
    bottom: calc(100% - 14px) !important;
    left: calc(100% - 5px) !important;
}
</style>
